
















import { Component, Vue, Prop } from 'vue-property-decorator'
import BasketSectionHeader from '@/components/BasketSectionHeader.vue'

@Component({
	components: {
		BasketSectionHeader,
	},
})
export default class BasketSection extends Vue {
	@Prop() readonly title!: string
}
